<template>
  <p
    class="text"
    :style="{
      fontSize: item.size || '14px',
      fontWeight: item.weight === 'bold' ? 'bold' : 'normal',
      color: item.color || '#333'
    }"
  >
    {{ item.text }}
  </p>
</template>

<script setup>
defineProps({
  item: Object
})
</script>

<style scoped>
.text {
  margin: 0;
  line-height: 1.4;
}
</style>
